module.exports = __webpack_public_path__ + "af1c87432b11073fe2fec3abcf618bf5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/guitar-edgy.png
// module id = 1851
// module chunks = 0